import { CustomerAmendmentLog } from '@/features/customers/components/HolderDetails/CustomerAmendmentLog';
import { AgreementCustomerPanel } from './AgreementCustomerPanel';
import type { useAgreementCustomerTab } from '../hooks/useAgreementCustomerTab';
import { ButtonLink } from '@/shared/components';

interface Props {
    agreementId: string;
    customer: ReturnType<typeof useAgreementCustomerTab>;
}

/** The agreement's Customer tab. `features/customers` owns the change forms and
 *  the log; this feature owns the page they are hosted on. */
export function AgreementCustomerTab({ agreementId, customer }: Props) {
    const { amendments } = customer;

    return (
        <AgreementCustomerPanel
            holder={customer.holder}
            source={customer.source}
            canChangeContactDetails={customer.canChangeContactDetails}
            action={
                <ButtonLink to={`/agreements/${agreementId}/customer/edit`} variant="outline" size="xs">
                    Change contact details
                </ButtonLink>
            }
            canChangeName={customer.canChangeName}
            nameAction={
                <ButtonLink to={`/agreements/${agreementId}/customer/name/edit`} variant="outline" size="xs">
                    Change name
                </ButtonLink>
            }
            log={
                customer.showsAmendments && (
                    <CustomerAmendmentLog
                        isLoading={amendments.query.isLoading}
                        isError={amendments.query.isError}
                        page={amendments.query.data}
                        currentPage={amendments.page}
                        onRetry={() => amendments.query.refetch()}
                        onPageChange={amendments.setPage}
                    />
                )
            }
        />
    );
}
